/** Demo clip — loaded on preview hover only (see LipSyncGenerator). */
export const LIP_SYNC_SAMPLE_VIDEO =
  'https://static.lip-sync.ai/lipsync/lip-sync-home/lip-sync-demo-new.mp4#t=0.001'

/** CDN 原图（srcset 回退；Generator 预览经 OSS w_1024） */
export const LIP_SYNC_SAMPLE_POSTER_CDN =
  'https://static.lip-sync.ai/lipsync/lip-sync-home/lip-sync-demo-new.webp'

/** 本地 WebP（由 scripts/optimize-preview-media.mjs 从 CDN 导出，见 page-quality-checklist） */
export const LIP_SYNC_SAMPLE_POSTER_384 = '/media/lip-sync-demo-poster-384.webp'
export const LIP_SYNC_SAMPLE_POSTER_768 = '/media/lip-sync-demo-poster-768.webp'

/** Generator 右侧 demo 预览：首屏使用本地缩略海报，视频仍按需加载 CDN 源。 */
export const LIP_SYNC_PREVIEW_POSTER_MOBILE = LIP_SYNC_SAMPLE_POSTER_768
export const LIP_SYNC_PREVIEW_POSTER_DESKTOP = LIP_SYNC_SAMPLE_POSTER_768

/** 默认 LCP 海报：中等视口常用 768 宽（preload / 营销区） */
export const LIP_SYNC_SAMPLE_POSTER = LIP_SYNC_SAMPLE_POSTER_768

export const LIP_SYNC_SAMPLE_POSTER_SRCSET = [
  `${LIP_SYNC_SAMPLE_POSTER_384} 384w`,
  `${LIP_SYNC_SAMPLE_POSTER_768} 768w`,
].join(', ')

/** 营销 / preload 用 sizes */
export const LIP_SYNC_PREVIEW_POSTER_SIZES =
  '(max-width: 1279px) 100vw, (max-width: 1280px) 768px, 1152px'

export const HERO_PREVIEW_CDN =
  'https://static.lip-sync.ai/lipsync/lip-sync-home/Hero.webp'

export const HERO_PREVIEW_320 = '/media/hero-preview-320.webp'
export const HERO_PREVIEW_384 = '/media/hero-preview-384.webp'
export const HERO_PREVIEW_640 = '/media/hero-preview-640.webp'
export const HERO_PREVIEW_960 = '/media/hero-preview-960.webp'
export const HERO_PREVIEW_1280 = '/media/hero-preview-1280.webp'

export const HERO_PREVIEW_DEFAULT = HERO_PREVIEW_640

export const HERO_PREVIEW_SRCSET = [
  `${HERO_PREVIEW_320} 320w`,
  `${HERO_PREVIEW_384} 384w`,
  `${HERO_PREVIEW_640} 640w`,
  `${HERO_PREVIEW_960} 960w`,
  `${HERO_PREVIEW_1280} 1280w`,
].join(', ')

/** Hero 右栏约半宽 */
export const HERO_PREVIEW_SIZES = '(max-width: 767px) 320px, (max-width: 1024px) 50vw, 50vw'
export const HERO_PREVIEW_LOW_PRIORITY_SIZES =
  '(max-width: 767px) 160px, (max-width: 1024px) 320px, 50vw'

const localMarketingHeroPreview = (prefix) => ({
  src: `/media/${prefix}-hero-preview-640.webp`,
  srcset: [
    `/media/${prefix}-hero-preview-384.webp 384w`,
    `/media/${prefix}-hero-preview-640.webp 640w`,
    `/media/${prefix}-hero-preview-960.webp 960w`,
    `/media/${prefix}-hero-preview-1280.webp 1280w`,
  ].join(', '),
})

const LOCAL_MARKETING_HERO_PREVIEW_PREFIXES = {
  'https://static.lip-sync.ai/lipsync/ai-avatar-generator/Hero_preview.webp': 'ai-avatar',
  'https://static.lip-sync.ai/lipsync/avatar-dialogue/Hero_preview.webp': 'avatar-dialogue',
  'https://static.lip-sync.ai/lipsync/talking-photo-ai/Hero_preview.webp': 'talking-photo',
  'https://static.lip-sync.ai/lipsync/talking-animals/Hero_preview.webp': 'talking-animals',
  'https://static.lip-sync.ai/lipsync/talking-avatar/Hero_preview.webp': 'talking-avatar',
  'https://static.lip-sync.ai/lipsync/ai-baby-podcast/Hero_preview.webp': 'ai-baby-podcast',
  'https://static.lip-sync.ai/lipsync/ai-influencer-generator/Hero_preview.webp': 'ai-influencer',
  'https://static.lip-sync.ai/lipsync/ai-news-anchor/Hero_preview.webp': 'ai-news-anchor',
  'https://static.lip-sync.ai/lipsync/ai-singing-photo/Hero_preview.webp': 'ai-singing-photo',
  'https://static.lip-sync.ai/lipsync/ai-animate-face-lip-sync/Hero_preview.webp': 'ai-animate-face-lip-sync',
}

const LOCAL_MARKETING_HERO_PREVIEWS = {
  [HERO_PREVIEW_CDN]: {
    src: HERO_PREVIEW_DEFAULT,
    srcset: HERO_PREVIEW_SRCSET,
  },
  ...Object.fromEntries(
    Object.entries(LOCAL_MARKETING_HERO_PREVIEW_PREFIXES).map(([url, prefix]) => [
      url,
      localMarketingHeroPreview(prefix),
    ]),
  ),
}

export function resolveLocalMarketingHeroPreview(url) {
  const cleanUrl = String(url ?? '').split('#')[0].split('?')[0]
  return LOCAL_MARKETING_HERO_PREVIEWS[cleanUrl]
}
